import { isValidLanguage } from '../../utils/text/translation';

// SkyMap Id's profile page, production for every environment: identity-service docs/profile-page.md.
const SKYMAP_ID_PROFILE_PAGE_URL = 'https://profile.skymap-id.com/';

/** Its "Back" link returns to `returnTo`, so pass the page the person left from. */
const buildSkyMapIdProfilePageUrl = (language: string, returnTo: string): string => {
  const url = new URL(SKYMAP_ID_PROFILE_PAGE_URL);
  url.searchParams.set('return_to', returnTo);
  if (isValidLanguage(language)) {
    url.searchParams.set('lang', language);
  }
  return url.href;
};

/** Takes the current tab to SkyMap Id's profile page; the page refuses framing and expects the same tab. */
const goToSkyMapIdProfilePage = (language: string) => {
  window.location.assign(buildSkyMapIdProfilePageUrl(language, window.location.href));
};

export { buildSkyMapIdProfilePageUrl, goToSkyMapIdProfilePage, SKYMAP_ID_PROFILE_PAGE_URL };
